import { render } from "./RecommendList.vue?vue&type=template&id=24bf9cf3&scoped=true"
import script from "./RecommendList.vue?vue&type=script&lang=ts"
export * from "./RecommendList.vue?vue&type=script&lang=ts"

import "./RecommendList.vue?vue&type=style&index=0&id=24bf9cf3&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-24bf9cf3"

export default script